import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const reportApi = {
  fetchReportDetails: (body) => {
    const { pageSize, pageNo } = body;
    const url = `/achievement/employee?pageSize=${pageSize}&pageNo=${pageNo}`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: body,
    });
  },
  fetchAchievementDetails: (body) => {
    const url = `/achievement/achievedTarget`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: body,
    });
  },
  fetchFocussedSku: (body) => {
    const { jmdoId, prmId } = body;
    //const jmdoId = 60892803;
    //const prmId = 702913441;
    const url = `/v1/jmdo/${jmdoId}/retailers/${prmId}/focusedSku`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  fetchAchievementDetailsCategoryWise: (body) => {
    const url = `/achievement/detailed`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: body,
    });
  },
  getTargetFilters: (employeeId) => {
    const url = `/v1/achievement/filters`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      headers: { "X-userId": employeeId },
    });
  },
  fetchAchievementDetailsFilterWise: (body) => {
    const { fromDate, toDate, keys, values, employeeId } = body;
    const url = `/v1/achievement/search?fromDate=${fromDate}&toDate=${toDate}&keys=${keys}&values=${values}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      headers: { "X-userId": employeeId },
    });
  },
  fetchIncentives: (body) => {
    const url = `/incentive/target-incentives`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: body,
    });
  },
  getSubordinateFilter: (id) => {
    const url = `sales-user/subordinates?id=${id}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      data: {},
    });
  },
  getSubordinates: (id) => {
    const url = `sales-user/jmdo?id=${id}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      data: {},
    });
  },
  fetchTargetAchievementData: (body) => {
    const { timeFilter, category, role, employeeId } = body;    
    const params = new URLSearchParams({
      period: timeFilter,
      role: role,
      employeeId: employeeId
    });
    if(category) {
      params.append("categoryName", category);
    }
    let url = `analytics/target-vs-achievement?${params.toString()}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      withCredentials: true,
    });
  },
  getSubordinatesForRole: (role) => {
    const url = `sales-user/subordinates-for-role?role=${role}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      data: {},
    });
  },
  getAllManagersForRole: ({ managerId, role, partnerName }) => {
    // For retailer role, use the retailer API endpoint
    if (role && role.toUpperCase() === "RETAILER") {
      const params = new URLSearchParams({
        managerId: managerId,
      });
      // If partnerName is provided, it's a search query
      if (partnerName) {
        params.append("partnerName", partnerName);
      }
      const url = `analytics/target-vs-achievement/retailers?${params.toString()}`;
      return request({
        method: HTTP_METHOD.GET,
        url,
        withCredentials: true,
      });
    }
    // For other roles, use the regular subordinates API
    const url = `/sales-user/subordinates-for-manager?managerId=${managerId}&role=${role}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      data: {},
    });
  },
  fetchEmployeeSummary: ({ managerId, role, period }) => {
    const params = new URLSearchParams({
      managerId: managerId,
      role: role,
      period: period,
    });
    const url = `analytics/target-vs-achievement/employee-summary?${params.toString()}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      withCredentials: true,
    });
  },
  searchEmployeeSummary: ({ managerId, role, period, searchId }) => {
    const params = new URLSearchParams({
      managerId: managerId,
      role: role,
      period: period,
      searchId: searchId,
    });
    const url = `analytics/target-vs-achievement/user-info-by-search?${params.toString()}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      withCredentials: true,
    });
  },
};

export default reportApi;
